import InView from '../components/InView';

const nlWaypointElements = document.querySelectorAll(
    '.lead,.t-image,.t-teaser,.image-teaser,.ce_youtube,.ce_vimeo,.t-portrait,.button-nav'
);

nlWaypointElements.forEach(el => new InView(el));
